/**
 * Created by Carsten Bühler
 * User: CBuehler on 17.02.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

const Icon = function ({ name, onClick }) {
    return <span className={'icon icon-map-' + name} onClick={onClick && onClick.bind(this)}/>;
}

Icon.propTypes = {
    name: PropTypes.string,
    onClick: PropTypes.func
};

export default Icon;


// WEBPACK FOOTER //
// ./js/components/Icon.jsx